import api from '@/api';
import { FONT,} from '@/assets/js/const'
import {getCustomList, getOrgsList, getWorksList} from "@/api/list/cvsEditor";
import Vue from 'vue';
import { Loading } from 'element-ui';

const state = () => ({
  experienceCustomSections:[],//经历库模板数据集合
  backUpExperienceList:{},//经历库模板数据整理之后的集合-备份
  experienceList: { //经历库模板数据整理之后的集合
    // works: [], //工作
    // orgs: [], //工作以外经历
    // edus: [], //教育
    // extras: { //其他
    //   certificates: [],
    //   interests: [],
    //   languages: [],
    //   others: [],
    //   skills: []
    // },

    // personal_summary: [], //个人总结
    // project_experience: [], //项目
    // reasearch_experience: [], //研究经历
    // honor: [], //荣誉
    // skill_list: [], //技能
    // custom: [],
  },
  daniuExperenceList: {},    //  大牛经历集合
  experienceTitleList:[], //左侧tab数据
  daniuExperenceTitleList: [],   // 大牛经历tab集合
  currentExperienceType:{ //当前经历库打开tab类型
    type:'',
    index:0
  },
  currentModule: {
    type: 'works',
    index: 1,
    title: '工作经历'
  },   // 当前大牛经历打开的模块
  daniuModuleList: [
    { type: 'edus', title: '教育经历' },
    { type: 'works', title: '工作经历' },
    { type: 'orgs', title: '工作以外经历' },
    { type: 'project_sections', title: '项目经历' },
    { type: 'summary_sections', title: '个人总结' },
  ],  //   大牛经历模块列表
  daniuCurrentExperienceType: {   // 当前大牛经历库打开的tab
    id: 0,
    cn: '',
    en: ''
  },
  sidebarOption:'check', //当前打开右侧菜单类型
  showFontState:false,
  userFontFamily: FONT,
  showManageAddGuide: false,//从check进入模块管理显示这个引导，每次都显示。。一次5秒中
  loadingFlag: false,   // 大牛经历加载loading
})

const getters = {
  // 当前的大牛经历
  daniuCurrentExperience: state => state.daniuExperenceList[state.currentModule.type] ? state.daniuExperenceList[state.currentModule.type] : [],
  currentExperience: state => state.experienceList[state.currentExperienceType.type]?state.experienceList[state.currentExperienceType.type]:[], //返回当前tab的数据
  getRootState: rootState => rootState,
  experienceListLength:state =>{ //获取当前模块的总数
    let experienceListLength = 0;
    Object.keys(state.experienceList).forEach(key=>{
      if(key!=='extras'){
        if(state.experienceList[key].length){
          experienceListLength += state.experienceList[key].length;
        }
      }else{
        Object.keys(state.experienceList.extras).forEach(skey=>{
          if(state.experienceList.extras[skey].length){
            experienceListLength += state.experienceList.extras[skey].length;
          }
        })
      }
    })
    return experienceListLength;
  }
}

const mutations = {
  // 更新loading状态
  updateLoading(state, data) {
    state.loadingFlag = data
  },
  // 更新大牛经历当前tab
  updateDaniuCurrentType(state, data) {
    state.daniuCurrentExperienceType = data
  },
  // 清空大牛经历数据
  delDaniuExperenceList(state) {
    state.daniuExperenceList = {}
  },
  // 大牛经理当前模块切换
  updateCurrentModule(state, data) {
    state.currentModule = data
  },
  // //更新经历库自定义模块总数据
  updateExperienceCustomSections(state, data) {
    state.experienceCustomSections = data;
  },
  //更新经历库整理之后的总数据
  updateExperienceList(state, data) {
    let newData = JSON.parse(JSON.stringify(data))
    state.experienceList = newData;
  },
  //更新经历库整理之后的总数据-备份
  updateBackUpExperienceList(state, data) {
    let newData = JSON.parse(JSON.stringify(data))
    state.backUpExperienceList = newData;
  },
  //更新当前tap
  updateCurrentExperienceType(state, data) {
    state.currentExperienceType = data;
  },
  //更新当前打开右侧菜单类型
  updateSidebarOption(state, data) {
    state.sidebarOption = data;
  },
  // 获取大牛经历tab标题数据
  getDaniuExperienceTitleList(state, data) {
    state.daniuExperenceTitleList = JSON.parse(JSON.stringify(data))
  },
  //同步tab标题数据
  updateExperienceTitleList(state, data) {
    let newData = JSON.parse(JSON.stringify(data))
    // console.log('updateExperienceTitleList=>>231',newData)
    state.experienceTitleList = newData;
  },
  //更新某一个标题名称
  updateExperienceTitleName(state, options) {
    console.log('updateExperienceTitleName=>>',options)
    let { title, type } = options;
    let experienceTitleList = state.experienceTitleList;
    experienceTitleList.forEach(item=>{
      if(item.type == type){
        item.title = title
      }
    })
    state.experienceTitleList = experienceTitleList;
  },
  // 更新大牛经历库的某个模块
  updateDaniuExperience(state, { key, value }) {
    let experienceList = JSON.parse(JSON.stringify(state.daniuExperenceList));
    if (experienceList[key]) {
      experienceList[key] = { ...experienceList[key], ...value }
    } else {
      experienceList[key] = { ...value }
    }
    state.daniuExperenceList = experienceList
  },
  //更新经历库某个模块-非other
  updateExperienceModule(state, options) {
    let newOptions = JSON.parse(JSON.stringify(options))
    let { key, info, operation, title, isCustom, updateBackUp } = newOptions;
    // console.log('mutations=>>>updateExperienceModule=>',newOptions)

    let editorRootState = this.getters['editor/getRootState'];
    if(window.location.href.includes('mentor')){
      return false;
    }
    let currentInfoOperation = editorRootState.currentInfo.operation;
    let experienceList = JSON.parse(JSON.stringify(state.experienceList));
    let experienceTitleList = JSON.parse(JSON.stringify(state.experienceTitleList));
    // console.log('修改之前experienceList=>>',experienceList)
    //获取名称
    let experienceTitle = title || '';
    if(isCustom){
      experienceTitle = editorRootState.cvDetail.submodule_info.custom_sections_titles[`${key}_title`] || editorRootState.currentInfo.title || '未命名模块'
    }else{
      experienceTitle = editorRootState.cvDetail.submodule_info[`${key}_title`] || editorRootState.currentInfo.title || '自定义模块'
    }

    //默认选中
    info.isSelect = true;
    // operation add添加小模块,update编辑小模块,moudel添加大模块
    if(operation === 'add'){
      let currentInfoId = editorRootState.currentInfo.data.id;
      console.log('editorRootState.currentInfo=>>>',editorRootState.currentInfo)
      console.log('operation=>>>',operation)
      console.log('currentInfoId=>>>',currentInfoId)

      if(!experienceList[key]){
        experienceList[key] = [];
      }
      //检测当前类型是否不存在于当前经历库中
      if(!experienceTitleList.filter(item=> item.type===key || item.id===key).length){
        experienceTitleList.push({
          type:key,
          title:experienceTitle
        })
      }
      // 判断单选类型，需要把别的反选掉
      if(key==='skill_list' || key==='personal_summary'){
        experienceList[key].forEach(item=>{
          //取消所有选中
          item.isSelect = false;
        })
      }else{
        experienceList[key] && experienceList[key].forEach(item=>{
          //当前是编辑，但是选择不同步，需要取消原来的选中状态
          if(currentInfoOperation!==operation && item.id === currentInfoId){
            item.isSelect = false
          }
        })
      }
      //合并当前模块
      experienceList[key].push(info);
    }else if(operation === 'edit'){
      //查找当前模块，覆盖
      experienceList[key] && experienceList[key].forEach((item,index)=>{
        if(item.id === info.id){
          experienceList[key][index] = info
        }
      })
    }else if(operation === 'module'){
      //查看经历库是否有此模块
      // console.log('experienceList[key]',!experienceList[key])
      if(!experienceList[key]){
        experienceList[key] = [];
      }
      // if(!(experienceList[key] && experienceList[key].length)){
      //检测当前类型是否不存在于当前经历库中
      if(!experienceTitleList.filter(item=> item.type===key || item.id===key).length){
        // console.log(experienceTitle,key)
        experienceTitleList.push({
          type:key,
          title: experienceTitle
        })
        //如果当前经历库没有数据，直接添加
        // console.log('!experienceList[key].length',!experienceList[key].length)
        if(!experienceList[key].length){
          experienceList[key] = [info];
        }
      }else{
        experienceList[key].push(info);
      }
      if(experienceTitleList.length === 1){
        state.currentExperienceType = { //当前经历库打开tab类型
          type:key,
          index:0
        }
      }
    }
    // console.log('experienceList=>>',experienceList)
    // console.log('experienceTitleList=>>',experienceTitleList)
    state.experienceList = experienceList;
    state.experienceTitleList = experienceTitleList;
    if(updateBackUp){
      state.backUpExperienceList = JSON.parse(JSON.stringify(experienceList));
    }
    let experienceListLength = this.getters['experience/experienceListLength'];
    if(experienceListLength===1 || true){
      state.currentExperienceType = {
        type:key,
        index:0
      }
    }

  },
  //更新经历库某个模块数据-other
  updateExperienceOtherModule(state, options) {
    let newOptions = JSON.parse(JSON.stringify(options))
    let { data, operation, title } = newOptions;
    // console.log('updateExperienceOtherModule=>>>',newOptions)

    let experienceList = JSON.parse(JSON.stringify(state.experienceList));
    let experienceTitleList = JSON.parse(JSON.stringify(state.experienceTitleList));
    let extras = experienceList.extras ? Object.keys(experienceList.extras) : [];

    if(operation === 'edit'){
      //修改情况下
      extras.forEach(key=>{
        let skey = key.substring(0,key.length-1);
        let bItem = experienceList.extras[key];
        bItem.forEach((item,index)=>{
          // console.log(item.id === data[skey].id)
          if(item.id === data[skey].id){
            data[skey].isSelect = true;
            bItem[index] = data[skey];
          }
        })
      })
    }else{
      // 如果没有other模块
      if(!extras || !extras.length){
        experienceList.extras = {
          certificates: [],
          interests: [],
          languages: [],
          others: [],
          skills: []
        };
      }
      // 添加模块的情况下
      if(operation ==='module' && !experienceTitleList.filter(item=>item.type === 'extras').length){
        experienceTitleList.push({
          type:'extras',
          title: title || '其他'
        })
      }
      //已经有此模块
      extras.forEach(key=>{
        let skey = key.substring(0,key.length-1);
        let bItem = experienceList.extras[key];

        data[skey].isSelect = true;
        if(!bItem || !bItem.length){
          experienceList.extras[key] = []
        }
        //添加进去
        experienceList.extras[key].push(data[skey])
      })
    }

    state.experienceList = experienceList;
    let experienceListLength = this.getters['experience/experienceListLength'];
    if(experienceListLength===1){
      state.currentExperienceType = {
        type:'extras',
        index:0
      }
    }
  },
  //删除经历库某个模块选中状态-非other
  deleteExperienceSelect(state, options) {
    let newOptions = JSON.parse(JSON.stringify(options))
    let { type, id } = newOptions;
    let experienceList = JSON.parse(JSON.stringify(state.experienceList));
    experienceList[type]?.forEach(item=>{
      if(item.id === id){
        item.isSelect = false;
      }
    })
    // 同步经历库选中状态
    state.experienceList = experienceList;
    // 同步经历库备份数据选中状态
    state.backUpExperienceList = experienceList;
  },
  //删除经历库某个模块选中状态-other
  deleteExperienceOtherSelect(state, options) {
    let newOptions = JSON.parse(JSON.stringify(options))
    let { type, data } = newOptions;
    // console.log(data)
    let experienceList = JSON.parse(JSON.stringify(state.experienceList));
    Object.keys(experienceList[type]).forEach(key=>{
      let skey = key.substring(0,key.length-1);
      let bItem = experienceList[type][key];
      bItem.forEach(item=>{
        if(item.id === data[skey].id){
          item.isSelect = false;
        }
      })
    })
    // 同步经历库选中状态
    state.experienceList = experienceList;
    // 同步经历库备份数据选中状态
    state.backUpExperienceList = experienceList;
  },
  //更新字体
  updateFontState(state, data){
    state.showFontState = data;
  },
  //初始化用户有那些字体
  initUserFontFamily(state, data){
    state.userFontFamily = data;
  },
  //
  setShowManageAddGuide(state, bool){
    state.showManageAddGuide = bool
  }
}

const actions = {
  // 获取分页的大牛教育经历数据请求
  getLimitDaniuEduRequest({ dispatch, state, commit }, payload) {
    let newData = JSON.parse(JSON.stringify(state.daniuExperenceList))
    let { page } = payload
    let { edus: { data } } = newData
    api.cvsEditor.getEdusList(payload).then(res => {
      if (res.code === 1000) {
        commit('updateLoading', false)
        let { data: { edus, page_count } } = res
        newData.edus = { data: [...data, ...edus], pages: page }
        commit('updateDaniuExperience', { key: 'edus', value: newData.edus })
      }
    })
  },
  // 获取分页的大牛工作经历经历数据请求
  getLimitDaniuWorkRequest({ dispatch, state, commit }, payload) {
    let newData = JSON.parse(JSON.stringify(state.daniuExperenceList))
    let { page } = payload
    let { works: { data } } = newData
    api.cvsEditor.getWorksList(payload).then(res => {
      if (res.code === 1000) {
        commit('updateLoading', false)
        let { data: { works, page_count } } = res
        newData.works = { data: [...data, ...works], pages: page }
        commit('updateDaniuExperience', { key: 'works', value: newData.works })
      }
    })
  },
  // 获取分页的大牛工作以外经历数据请求
  getLimitDaniuOrgRequest({ dispatch, state, commit }, payload) {
    let newData = JSON.parse(JSON.stringify(state.daniuExperenceList))
    let { page } = payload
    let { orgs: { data } } = newData
    api.cvsEditor.getOrgsList(payload).then(res => {
      if (res.code === 1000) {
        commit('updateLoading', false)
        let { data: { orgs, page_count } } = res
        newData.orgs = { data: [...data, ...orgs], pages: page }
        commit('updateDaniuExperience', { key: 'orgs', value: newData.works })
      }
    })
  },
  // 获取分页的大牛自定义模块数据请求
  getLimitDaniuCustomRequest({ dispatch, state, commit }, payload) {
    let newData = JSON.parse(JSON.stringify(state.daniuExperenceList))
    let { page } = payload
    // let { project_sections, summary_sections }  = newData
    api.cvsEditor.getCustomList(payload).then(res => {
      if (res.code === 1000) {
        commit('updateLoading', false)
        // let { data: { orgs, page_count } } = res
        // newData.orgs = { data: [...data, ...orgs], pages: page }
        // commit('updateDaniuExperience', { key: 'orgs', value: newData.works })
        let { data: { project_sections, summary_sections, page_count } } = res
        let project = []
        let personal = []
        project_sections.forEach((item, index) => {
          project.push(...item.infos)
        })
        summary_sections.forEach((item, index) => {
          personal.push(...item.infos)
        })
        newData.project_sections = { data: [...newData.project_sections, ...project], pages: page }
        newData.summary_sections = { data: [...newData.summary_sections, ...personal], pages: page }
        commit('updateDaniuExperience', { key: 'project_sections', value: newData.project_sections })
        commit('updateDaniuExperience', { key: 'summary_sections', value: newData.summary_sections })
      }
    })
  },
  // 获取分页的大牛经历数据
  getLimitDaniuExperience({ dispatch, state, commit }, { page, cvDetail }) {
    commit('updateLoading', true)
    let { basic_info: { lang } } = cvDetail;
    let payload = { lang, tag: state.daniuCurrentExperienceType.en, type: 'sample', page }
    switch (state.currentModule.type) {
      case 'edus': dispatch('getLimitDaniuEduRequest', payload); break;
      case 'works': dispatch('getLimitDaniuWorkRequest', payload); break;
      case 'orgs': dispatch('getLimitDaniuOrgRequest', payload); break;
      case 'project_sections': dispatch('getLimitDaniuCustomRequest', payload); break;
      case 'summary_sections': dispatch('getLimitDaniuCustomRequest', payload); break;
    }
  },
  // 更新大牛经历当前tab
  updateDaniuCurrentType({ dispatch, state, commit }, data) {
    return new Promise((resolve, reject) => {
      // state.daniuCurrentExperienceType = data
      commit('updateDaniuCurrentType', data)
      resolve()
    })
  },
  // 获取大牛经历tab
  async getDaniuTabs({ dispatch, state, commit }) {
    try {
      let res = await api.cvs.getDaniuTags()
      if (res.code === 1000) {
        let { data: { tags: { job } } } = res
        commit('getDaniuExperienceTitleList', job)
        commit('updateDaniuCurrentType', job.length > 0 ? job[0] : { id: 0, cn: '', en: '' })
        return res
      }
    } catch (e) {

    }
  },
  // 获取大牛工作经历
  getDaniuWorks: ({ dispatch, state, commit }, payload) => {
    api.cvsEditor.getWorksList(payload).then(res => {
      commit('updateLoading', false)
      if (res.code === 1000) {
        let { data: { works, page_count } } = res
        commit('updateDaniuExperience', { key: 'works', value: { data: works, page_count, pages: 1 } })
      }
    })
  },
  // 获取大牛教育经历
  getDaniuEdus: ({ dispatch, state, commit }, payload) => {
    api.cvsEditor.getEdusList(payload).then(res => {
      commit('updateLoading', false)
      if (res.code === 1000) {
        let { data: { edus, page_count } } = res
        commit('updateDaniuExperience', { key: 'edus', value: { data: edus, page_count, pages: 1 } })
      }
    })
  },
  // 获取大牛 orgs
  getDaniuOrgs: ({ dispatch, state, commit }, payload) => {
    api.cvsEditor.getOrgsList(payload).then(res => {
      commit('updateLoading', false)
      if (res.code === 1000) {
        let { data: { orgs, page_count } } = res
        commit('updateDaniuExperience', { key: 'orgs', value: { data: orgs, page_count, pages: 1 } })
      }
    })
  },
  // 获取大牛 project_sections
  getDaniuOther: ({ dispatch, state, commit }, payload) => {
    api.cvsEditor.getCustomList(payload).then(res => {
      commit('updateLoading', false)
      if (res.code === 1000) {
        // let { data: { custom_sections, page_count } } = customRes
        let { data: { project_sections, summary_sections, page_count } } = res
        let project = []
        let personal = []
        project_sections.forEach((item, index) => {
          project.push(...item.infos)
        })
        summary_sections.forEach((item, index) => {
          personal.push(...item.infos)
        })
        commit('updateDaniuExperience', { key: 'project_sections', value: { data: project, page_count, pages: 1 } })
        commit('updateDaniuExperience', { key: 'summary_sections', value: { data: personal, page_count, pages: 1 } })
      }
    })
  },
  // 获取大牛经历库信息
  getDaniuExperienceList: async ({ dispatch, state, commit }, cvDetail) => {
    commit('updateLoading', true)
    let { submodule_info, basic_info: { lang } } = cvDetail;
    let payload = { lang, tag: state.daniuCurrentExperienceType.en, type: 'sample' }
    switch (state.currentModule.type) {
      case 'works': dispatch('getDaniuWorks', payload); break;
      case 'edus': dispatch('getDaniuEdus', payload); break;
      case 'orgs': dispatch('getDaniuOrgs', payload); break;
      case 'project_sections': dispatch('getDaniuOther', payload); break;
      case 'summary_sections': dispatch('getDaniuOther', payload); break;
    }
    return
    try {
      let getDaniuEdus = api.cvsEditor.getEdusList(payload)
      let getDaniuWorks = api.cvsEditor.getWorksList(payload)
      let getDaniuOrgs = api.cvsEditor.getOrgsList(payload)
      let getDaniuCustoms = api.cvsEditor.getCustomList(payload)
      Promise.all([getDaniuEdus, getDaniuWorks, getDaniuOrgs, getDaniuCustoms]).then(([eduRes, workRes, orgRes, customRes]) => {
        commit('delDaniuExperenceList')
        commit('updateLoading', false)
        if (eduRes.code === 1000) {
          let { data: { edus, page_count } } = eduRes
          commit('updateDaniuExperience', { key: 'edus', value: { data: edus, page_count, pages: 1 } })
        }
        if (workRes.code === 1000) {
          let { data: { works, page_count } } = workRes
          commit('updateDaniuExperience', { key: 'works', value: { data: works, page_count, pages: 1 } })
        }
        if (orgRes.code === 1000) {
          let { data: { orgs, page_count } } = orgRes
          commit('updateDaniuExperience', { key: 'orgs', value: { data: orgs, page_count, pages: 1 } })
        }
        if (customRes.code === 1000) {
          // let { data: { custom_sections, page_count } } = customRes
          let { data: { project_sections, summary_sections, page_count } } = customRes
          let project = []
          let personal = []
          project_sections.forEach((item, index) => {
            project.push(...item.infos)
          })
          summary_sections.forEach((item, index) => {
            personal.push(...item.infos)
          })
          commit('updateDaniuExperience', { key: 'project_sections', value: { data: project, page_count, pages: 1 } })
          commit('updateDaniuExperience', { key: 'summary_sections', value: { data: personal, page_count, pages: 1 } })
        }
        // 超时主动关闭loading
        setTimeout(() => {
          commit('updateLoading', false)
        },10000)
      })
    } catch (e) {

    }
  },
  //获取cv基本信息
  getExperienceList: async ({ dispatch, state, commit }, cvDetail)=>{
    let { submodule_info, basic_info } = cvDetail;
    let { sections_position, custom_sections_titles, edus_ids, orgs_ids, works_ids } = submodule_info;
    let { lang, kind } = basic_info;
    try {
      let getAllEdus = api.cvsEditor.getEdusList({lang});
      let getAllOrgs = api.cvsEditor.getOrgsList({lang});
      let getAllWorks = api.cvsEditor.getWorksList({lang});
      let getAllExtras = api.cvsEditor.getExtras({section_lang: lang});
      let getAllCustom = api.cvsEditor.getCustomList({lang});
      await Promise.all([getAllEdus, getAllOrgs, getAllWorks, getAllExtras, getAllCustom]).then((resAll) => {
        // console.log(resAll)
        let obj = {
          // works: [], //工作
          // orgs: [], //工作以外经历
          // edus: [], //教育
          // extras: {}, //其他
        }
        let experienceTitleList = [];
        //获取所有key的名字
        let sections_position_names = sections_position.map(item=> item.type );

        if(resAll[0].code === 1000){
          obj.edus = resAll[0].data.edus;
          //插入标题列
          if(obj.edus.length){
            experienceTitleList.push({
              type:'edus',
              title:submodule_info.edus_title || ''
            })
          }
          // experienceTitleList.push({
          //   type:'edus',
          //   title:submodule_info.edus_title || ''
          // })
          // if(sections_position_names.includes('edus')){
          obj.edus.forEach((item,index)=>{
            //如果是编辑，只选中当前简历里选中的
            if(!(kind==='template' || kind==='sample')){
              item.isSelect = edus_ids.includes(item.id)
            }else{
              item.isSelect = index<2
            }
          })
          // }
        }
        if(resAll[1].code === 1000){
          obj.orgs = resAll[1].data.orgs;
          //插入标题列
          if(obj.orgs.length){
            experienceTitleList.push({
              type:'orgs',
              title:submodule_info.orgs_title || ''
            })
          }
          // experienceTitleList.push({
          //   type:'orgs',
          //   title:submodule_info.orgs_title || ''
          // })

          // if(sections_position_names.includes('orgs')){
            obj.orgs.forEach((item,index)=>{
              //如果是编辑，只选中当前简历里选中的
              if(!(kind==='template' || kind==='sample')){
                item.isSelect = orgs_ids.includes(item.id)
              }else{
                item.isSelect = index<2
              }
            })
          // }
        }
        if(resAll[2].code === 1000){
          obj.works = resAll[2].data.works;
          //插入标题列
          if(obj.works.length){
            experienceTitleList.push({
              type:'works',
              title:submodule_info.works_title || ''
            })
          }
          // experienceTitleList.push({
          //   type:'works',
          //   title:submodule_info.works_title || ''
          // })
          // if(sections_position_names.includes('works')){
            obj.works.forEach((item,index)=>{
              //如果是编辑，只选中当前简历里选中的
              if(!(kind==='template' || kind==='sample')){
                item.isSelect = works_ids.includes(item.id)
              }else{
                item.isSelect = index<2
              }
            })
          // }
        }
        if(resAll[3].code === 1000){
          obj.extras = resAll[3].data.others;
          // console.log(213131213,resAll[3].data.others)
          let extrasLength = 0;
          // if(sections_position_names.includes('extras')){
            for(let key in obj.extras){
              let keyName = key.substr(0, key.length-1);
              extrasLength += obj.extras[key].length;
              obj.extras[key].forEach((item,index)=>{
                //如果是编辑，只选中当前简历里选中的
                if(!(kind==='template' || kind==='sample')){
                  item.isSelect = submodule_info[keyName+'_id'] === item.id
                }else{
                  item.isSelect = index<1
                }
              })
            }
          // }
          //插入标题列
          if(Object.keys(obj.extras).length && extrasLength){
            experienceTitleList.push({
              type:'extras',
              title:submodule_info.extras_title || ''
            })
          }
          // experienceTitleList.push({
          //   type:'extras',
          //   title:submodule_info.extras_title || ''
          // })
        }
        if(resAll[4].code === 1000){
          let custom_sections = resAll[4].data.custom_sections;
          commit('updateExperienceCustomSections', JSON.parse(JSON.stringify(custom_sections)))
          custom_sections && custom_sections.forEach(item=>{
            //循环详情，检测选中状态
            let info_ids = [];
            //整理id
            sections_position.forEach(Pitem=>{
              if(Pitem.type === item.category || Pitem.id === item.id){
                Pitem.actionId = item.id
                info_ids = Pitem.info_ids;
              }
            })
            if(item.infos.length){
              //插入标题列
              // console.log(item)
              experienceTitleList.push({
                type:item.category || item.id,
                id: item.id,
                title:item.title || custom_sections_titles[item.id+'_title'] || '未命名模块'
              })
            }
            // experienceTitleList.push({
            //   type:item.category || item.id,
            //   id: item.id,
            //   title:item.title || custom_sections_titles[item.id+'_title'] || '未命名模块'
            // })
            //整理选中状态
            item.infos.forEach((sitem,sindex)=>{
              if(!(kind==='template' || kind==='sample')){
                sitem.isSelect = info_ids.includes(sitem.id)
              }else{
                sitem.isSelect = (item.category==='skill_list' || item.category==='project_experience')
                                ? sindex<1  : sindex<2;
              }
            })

            //最终赋值
            obj[item.category || item.id] = item.infos;
          })

        }

        //同步tab标题数据
        commit('updateExperienceTitleList',experienceTitleList)
        //同步tab标题默认选项
        commit('updateCurrentExperienceType',{type: experienceTitleList[0] ? experienceTitleList[0].type : '',index:0})
        //同步集合数据
        commit('updateExperienceList',obj)
        //同步集合数据-备份
        commit ('updateBackUpExperienceList',obj)

      });

    } catch (error) {
      console.log('getupdateExperienceList=>error=>>>',error)
    }

  },

}


export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
